import _ from 'lodash';

// We have a bug on the backend that is allowing multiple answers for the same question
// The workaround is to get the latest modified answer.
const getQuestionAnswer = (answers, questionId) => {
  if (!questionId) return null;
  return _.chain(answers)
    .orderBy('updatedAt', 'desc')
    .find((ans) => ans.question.id === questionId)
    .value();
};

export default getQuestionAnswer;
